import React, { useState, useEffect } from 'react';
import {
  Grid,
  TextField,
  Stack,
  Tab,
  Tabs,
  Box,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
  // InputLabel,
  FormControl,
  MenuItem,
  Select,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import Activationtable from './ActivationTable';
import CspCode from './CspCode';
import { CspCodeActivateApiList, CspCodeActivateApiView } from 'API/Services';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';
import { FiBankList } from 'API/Reports';
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Index = () => {
  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`
    };
  }
  const location = useLocation();
  const StateData = location.state;
  console.log('StateData', StateData);
  const userType = sessionStorage.getItem('UserType');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [TotalCount, setTotalCount] = useState('');

  const [value, setValue] = useState(StateData ? StateData.setValue : userType === 'ft' ? 1 : 0);
  const [rowsPerPageAct, setRowsPerPageAct] = useState(10);
  const [pageAct, setPageAct] = useState(0);
  const [TotalCountAct, setTotalCountAct] = useState('');
  const handleChangePageAct = (event, newPage) => {
    setPageAct(newPage);
  };

  const handleChangeRowsPerPageAct = (event) => {
    setRowsPerPageAct(event.target.value);
    setPageAct(0);
  };
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    handleClear();
  };
  // const navigate = useNavigate();

  const [ResData, setResData] = useState('');
  const [IsLoading, setIsLoading] = useState(false);
  const [BankList, setBankList] = useState(null);
  const [ListData, setListData] = useState('');
  // Search States
  const [searchAgentName, setSearchAgentName] = useState('');
  const [searchAgentCode, setSearchAgentCode] = useState('');
  const [searchBankName, setSearchBankName] = useState('');

  const handleClear = () => {
    setSearchBankName('');
    setSearchAgentCode('');
    setSearchAgentName('');
  };
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z\s]/g, '');
  };
  const handleCodeInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z0-9]/g, '');
  };
  useEffect(() => {
    if (value === 0) {
      setResData([]);
      CspCodeActivateApiView(
        searchBankName,
        searchAgentCode,
        searchAgentName,
        pageAct + 1,
        rowsPerPageAct,
        setIsLoading,
        setResData,
        setTotalCountAct
      );
    }
  }, [value, searchBankName, searchAgentCode, searchAgentName, pageAct, rowsPerPageAct]);
  useEffect(() => {
    if (value === 1) {
      setListData([]);
      CspCodeActivateApiList(
        searchBankName,
        searchAgentCode,
        searchAgentName,
        page + 1,
        rowsPerPage,
        setIsLoading,
        setListData,
        setTotalCount
      );
    }
  }, [value, searchBankName, searchAgentCode, searchAgentName, page, rowsPerPage]);

  const handleReFetch = () => {
    setListData([]);
    CspCodeActivateApiList(
      searchBankName,
      searchAgentCode,
      searchAgentName,
      page + 1,
      rowsPerPage,
      setIsLoading,
      setListData,
      setTotalCount
    );
  };

  useEffect(() => {
    FiBankList(setBankList);
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  return (
    <Grid container>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={IsLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid item xl={12} width="100%">
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
            <Typography variant="h4">{userType === 'ft' ? 'CSP Code Activation' : 'CSP Code Creation &  Activation'}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {/* <MainCard title={userType === 'ft' ? 'CSP Code Activation' : 'CSP Code Creation &  Activation'}> */}
            {/* <Typography variant='h3'>CSP Code Activation</Typography> */}
            <Grid container spacing={2} alignItems="center">
              <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
                <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                  Agent Name
                </Typography>
                <TextField
                  // label="Agent name"
                  fullWidth
                  size="small"
                  onInput={handleInput}
                  value={searchAgentName}
                  onChange={(e) => setSearchAgentName(e.target.value)}
                />
              </Grid>
              <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
                <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                  Agent Code
                </Typography>
                <TextField
                  fullWidth
                  // label="Agent Code"
                  size="small"
                  onInput={handleCodeInput}
                  value={searchAgentCode}
                  onChange={(e) => setSearchAgentCode(e.target.value)}
                />
              </Grid>
              <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
                {/* <TextField
                label="Bank name"
                fullWidth
                onInput={handleInput}
                value={searchBankName}
                onChange={(e) => setSearchBankName(e.target.value)}
              /> */}
                <FormControl fullWidth>
                  {/* <InputLabel id="demo-simple-select-label">Bank name</InputLabel> */}
                  <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
                    Bank Name
                  </Typography>
                  <Select
                    // label="Bank name"
                    size="small"
                    fullWidth
                    onInput={handleInput}
                    value={searchBankName ? searchBankName : 'select'}
                    onChange={(e) => setSearchBankName(e.target.value)}
                  >
                    <MenuItem value={'select'} disabled>
                      Select
                    </MenuItem>
                    {BankList &&
                      BankList.map((bank, index) => (
                        <MenuItem value={bank.Bankname} key={index}>
                          {bank.Full_Bank_Name.toUpperCase()}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid spacing={2} item xl={3} mt={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={!searchBankName && !searchAgentCode && !searchAgentName}
                  sx={{
                    backgroundColor: '#592375',
                    color: '#FFFFFF',
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#592375'
                    }
                  }}
                  size="small"
                  onClick={() => handleClear()}
                >
                  Clear
                </Button>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        {/* </MainCard> */}
      </Grid>
      <Grid item xl={12} width="100%" mt={1}>
        <MainCard sx={{ width: '100%', overflow: 'scroll' }}>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              {userType === 'ft' ? (
                <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
                  {/* <Tab label="Pending for code creation" {...a11yProps(0)} disabled={userType==='ft'}/> */}
                  <Tab label="Csp code activation" sx={{ color: 'primary.main', pointerEvents: 'none' }} {...a11yProps(1)} />
                </Tabs>
              ) : (
                <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
                  <Tab label="Pending for code creation" {...a11yProps(0)} disabled={userType === 'ft'} />
                  <Tab label="Code activation and E-Agreement" {...a11yProps(1)} />
                </Tabs>
              )}
              {/* <Tabs value={value} onChange={handleTabChange} aria-label="basic tabs example">
                <Tab label="Pending for code creation" {...a11yProps(0)} disabled={userType==='ft'}/>
                <Tab label="Code activation and E-Agreement" {...a11yProps(1)} />
              </Tabs> */}
            </Box>
            <CustomTabPanel value={value} index={0}>
              {ResData && ResData.length ? (
                <Activationtable
                  ResData={ResData}
                  TotalCount={TotalCountAct}
                  page={pageAct}
                  rowsPerPage={rowsPerPageAct}
                  handleChangeRowsPerPage={handleChangeRowsPerPageAct}
                  handleChangePage={handleChangePageAct}
                />
              ) : (
                <Stack justifyContent="center" alignItems="center">
                  {/* <CircularProgress /> */}
                  <Typography mt={1} variant="h5">
                    No data found
                  </Typography>
                </Stack>
              )}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              {ListData && ListData.length ? (
                <CspCode
                  ResData={ListData}
                  TotalCount={TotalCount}
                  handleReFetch={handleReFetch}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  handleChangePage={handleChangePage}
                />
              ) : (
                <Stack justifyContent="center" alignItems="center">
                  {/* <CircularProgress /> */}
                  <Typography mt={1} variant="h5">
                    No data found
                  </Typography>
                </Stack>
              )}
            </CustomTabPanel>
          </Box>{' '}
        </MainCard>
      </Grid>
    </Grid>
  );
};

export default Index;
